(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1048],{

/***/ 61048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_DescriptionListWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./storyblok/components/DynamicComponent.tsx + 1 modules
var DynamicComponent = __webpack_require__(79426);
// EXTERNAL MODULE: ./components/global/Tag/index.tsx + 1 modules
var Tag = __webpack_require__(32486);
// EXTERNAL MODULE: ./components/global/DescriptionList/DescriptionList.module.scss
var DescriptionList_module = __webpack_require__(75005);
var DescriptionList_module_default = /*#__PURE__*/__webpack_require__.n(DescriptionList_module);
;// CONCATENATED MODULE: ./components/global/DescriptionList/index.tsx






var DescriptionList = function(param1) {
    var _className = param1.className, className = _className === void 0 ? "" : _className, _items = param1.items, items = _items === void 0 ? [] : _items, _foregroundColor = param1.foregroundColor, foregroundColor = _foregroundColor === void 0 ? "" : _foregroundColor, padding = param1.padding, mobilePadding = param1.mobilePadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
        className: [
            (DescriptionList_module_default()).DescriptionList,
            className
        ].join(" "),
        style: {
            "--description-list-foreground-color": foregroundColor
        },
        children: items.map(function(param) {
            var term = param.term, details = param.details, tags = param.tags, url = param.url, _tagsWithLinks = param.tagsWithLinks, tagsWithLinks = _tagsWithLinks === void 0 ? [] : _tagsWithLinks, _detailsIsInMono = param.detailsIsInMono, detailsIsInMono = _detailsIsInMono === void 0 ? false : _detailsIsInMono;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                        className: (DescriptionList_module_default()).DescriptionList__term,
                        children: term
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        className: (0,clsx_m/* default */.Z)((DescriptionList_module_default()).DescriptionList__details, [
                            padding && (DescriptionList_module_default())["DescriptionList__details--padding"],
                            !mobilePadding && (DescriptionList_module_default())["DescriptionList__details--noPaddingMobile"]
                        ]),
                        children: url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: url,
                            children: details
                        }) || details && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)(detailsIsInMono && "u-mono-font"),
                            children: details
                        }) || (tagsWithLinks.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicComponent/* default */.Z, {
                            blok: tagsWithLinks[0]
                        }) : tags.length && tags.split(",").map(function(tag, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                                label: tag
                            }, i);
                        })) || ""
                    })
                ]
            }, term);
        })
    });
};
/* harmony default export */ var global_DescriptionList = (DescriptionList);

;// CONCATENATED MODULE: ./storyblok/components/DescriptionListWrapper.tsx


var DescriptionListWrapper = function(param) {
    var blok = param.blok;
    var list_items = blok.list_items, foregroundColor = blok.foregroundColor, padding = blok.padding, mobilePadding = blok.mobilePadding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(global_DescriptionList, {
        items: list_items,
        foregroundColor: foregroundColor,
        padding: padding,
        mobilePadding: mobilePadding
    });
};
/* harmony default export */ var components_DescriptionListWrapper = (DescriptionListWrapper);


/***/ }),

/***/ 75005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"DescriptionList":"DescriptionList_DescriptionList__ecyzz","DescriptionList__term":"DescriptionList_DescriptionList__term__azED_","DescriptionList__details":"DescriptionList_DescriptionList__details__RzgiR","DescriptionList__details--padding":"DescriptionList_DescriptionList__details--padding__fwAyF","DescriptionList__details--noPaddingMobile":"DescriptionList_DescriptionList__details--noPaddingMobile__QPnG_"};

/***/ })

}]);